import React from 'react';
import style from './style.module.css';

const Radio = ({
    id,
    name,
    label,
    checkedValue = false,
    input: { onChange, value },
    disabled = false,
    className = "",
    onRadioCheck = false,
    required = true,
}) => {
    const onChangeHandler = (selected) => {
        onChange(selected);
        if (onRadioCheck !== false) {
            onRadioCheck(selected);
        }
    };

    const selected = (checkedValue || checkedValue === 0) ? checkedValue : label;

    return (
        <label htmlFor={id} className={`${style.filterRadio}${className ? ' ' + className : ''}${disabled ? ` ${style.disabled}` : ``}`}>
            <div className={`${style.filterRadioIcon}`}>
                <input
                    type="radio"
                    onChange={() => { onChangeHandler(selected) }}
                    id={id}
                    name={name}
                    required={required}
                    checked={value === selected}
                    disabled={disabled}
                />
                <div className={style.filterRadioCircle}></div>
            </div>
            <div className={style.filterRadioLabel}>{label}</div>
        </label>
    );
};

export default Radio;
